import type {UpdateRepresentativeFormPayload} from "./update-representative.schema";
import type {UpdateRepresentativeRequest} from "@project/sdk/sales";

export const updateRepresentativeMapper = {
  toSdk: (payload: UpdateRepresentativeFormPayload): UpdateRepresentativeRequest => ({
    company: {
      companyId: payload.companyId,
      companyName: payload.companyName,
      partyProfile: {
        address: {address: payload.address},
        country: payload.country,
        phone: {
          regionCode: payload.phonePrefix,
          nationalNumber: payload.phoneNumber,
        },
        websiteUrl: payload.websiteUrl,
      },
    },
    logoUrl: payload.logoUrl,
    exclusive: payload.exclusive,
  }),
};
